<template>
  <div class="small-ocean">
    <b-container class="about">
      <b-row>
        <b-col cols=2></b-col>
        <b-col cols=8>
      <h1>About</h1>
      <p>In 2008 we created LearningPlanet to be an online resource for kids. We created many activities to help kids learn a variety of math, language, and problem solving skills. Most of these were in the form of games. Students all over the world use these games on a daily basis.</p>

<p>Initially these games were built with a tool called Macromind Director. This tool was unique because it allowed us to publish games to the internet using the Shockwave plugin. Many games were created this way. Unfortunately Shockwave no longer functions on most current computers, so we had to move on.</p>

<p>Flash was an upcoming tool that soon became powerful enough to allow us to create games. Flash was great because it allowed artists to animate using vector artwork instead of pixel artwork. This meant that games were much smaller in size and could be downloaded much more quickly than their Shockwave counterparts. We built most of our games using Flash and its programming language, Actionscript.</p>

<p>As years went by there was a movement away from Flash by mobile hardware manufacturers. This was primarily because Flash used quite a bit of processor time, causing reduced battery life on mobile devices. So Flash games would not work on most phones and tablets. It still works fine on computers, but a new mobile friendly solution is needed.</p>

<p>Fortunately the built-in web browsers of most mobile devices are fully capable of displaying interactive content on their own. So our current challenge is to figure out a way to rebuild our Shockwave and Flash games in a new tool. Stay tuned as we work to solve this. In the mean time we urge you to <router-link to="help">install the Flash Player on your computer</router-link> and enjoy the many games we have developed over the years.</p>
      <div @click="goBack()">Go Back</div>
    </b-col>
    </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'About',
  props: {
    msg: String
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ocean {
  background-image:url("../assets/img/world/ocean.jpg");
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  min-height:300px;
  margin-top:40px;
  height: 100%;
}
.small-ocean {
  background-image:url("../assets/img/2016/water_banner.png");
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  margin-top: 0px;
  padding-top: 0px;
  min-height:300px;
}
.about {
  margin-top: 100px;
}
.about p {
  font-size: 16pt;
  text-align: left;
}
</style>
